import React, { useState } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import Modal from 'components/Modal/Modal';
import SuccessCheckmark from 'components/SuccessCheckmark/SuccessCheckmark';
import { useMutationCreateSuperAdmin } from 'Customers/hooks/useCustomers';

import AddAdminForm from './AddAdminForm';

const AddAdminModal = ({ isOpen, onClose, id, users }) => {
  const queryClient = useQueryClient();
  const [errorMessage, setErrorMessage] = useState('');
  const { isLoading, mutate: CreateSuperAdmin } = useMutationCreateSuperAdmin();

  const initialValues = {};

  const handleSubmit = (data) =>
    new Promise((resolve) => {
      CreateSuperAdmin(
        { id, data },
        {
          onSuccess: async () => {
            await queryClient.invalidateQueries(['customersAccounts', id]);
            setErrorMessage('');
            onClose();
            resolve();
          },
          onError: (err) => {
            const description = err?.response?.data?.errors?.description;
            // Prefer the specific backend detail (e.g. "user already exists"),
            // fall back to its message, then a generic label.
            setErrorMessage(description?.details || description?.message || 'Failed creating admin');
            resolve();
          },
        }
      );
    });
  return (
    <Modal
      isOpen={isOpen}
      shouldCloseOnOverlayClick
      title={'Add Admin'}
      styles={{
        width: '560px',
        padding: 0,
        height: '480px',
      }}
      onRequestClose={() => {
        onClose();
      }}
    >
      {errorMessage && <SuccessCheckmark text={errorMessage} isFailed onClose={() => setErrorMessage('')} />}
      <AddAdminForm
        onClose={onClose}
        onSubmit={handleSubmit}
        isLoading={isLoading}
        initialValues={initialValues}
        users={users?.data || []}
        failed={!!errorMessage}
      />
    </Modal>
  );
};

export default AddAdminModal;
